/**
 * AddCircleIcon/index.js
 * desc: content add icon w circle bg fill
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const AddCircleIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="add-circle icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.addCircle.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fillRule="evenodd" d="M0 10C0 4.48 4.48 0 10 0s10 4.48 10 10-4.48 10-10 10S0 15.52 0 10zm11 1h4V9h-4V5H9v4H5v2h4v4h2v-4z"/></svg>
    </IconButton>
);


export default AddCircleIcon;
